import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/scale.css';
import './Header.css';

export default function SettingsIcon({ svgClass, wrapperClass }) {
  return (
    <Tippy
      content={'Settings'}
      className={'tippy-tooltip'}
      // delay={[1000, 0]}
      animation={'scale'}
      touch={false}>
      <div className={wrapperClass}>
        <svg
          className={svgClass}
         
          // width='31.407'
          // height='33'
          viewBox='0 0 31.407 33'>
          <path
            id='Settings_icon'
            data-name='Settings icon'
            d='M-549.066,6707h-6.461a.825.825,0,0,1-.808-.7l-.605-4.374a11.755,11.755,0,0,1-2.726-1.607l-4.018,1.649a.853.853,0,0,1-.28.047.793.793,0,0,1-.709-.418l-3.23-5.713a.863.863,0,0,1,.2-1.052l3.412-2.722a10.56,10.56,0,0,1-.122-1.609,10.51,10.51,0,0,1,.142-1.609l-3.412-2.722a.808.808,0,0,1-.2-1.051l3.23-5.715a.8.8,0,0,1,.7-.426.786.786,0,0,1,.288.056l4.018,1.649a12.125,12.125,0,0,1,2.726-1.609l.605-4.371a.792.792,0,0,1,.788-.7h6.461a.81.81,0,0,1,.806.7l.607,4.371a11.752,11.752,0,0,1,2.724,1.609l4.019-1.649a.878.878,0,0,1,.279-.045.8.8,0,0,1,.711.416l3.23,5.715a.864.864,0,0,1-.2,1.051l-3.412,2.722a10.578,10.578,0,0,1,.12,1.609,14.054,14.054,0,0,1-.1,1.609l3.372,2.722a.811.811,0,0,1,.2,1.052l-3.23,5.713a.8.8,0,0,1-.7.426.775.775,0,0,1-.288-.055l-4.018-1.649a12.093,12.093,0,0,1-2.726,1.607l-.607,4.374A.781.781,0,0,1-549.066,6707Zm-3.228-23a6.02,6.02,0,0,0-6.028,6,6.022,6.022,0,0,0,6.028,6,6.021,6.021,0,0,0,6.027-6A6.02,6.02,0,0,0-552.294,6684Z'
            transform='translate(568 -6674)'
            fill='#fff'
          />
        </svg>
      </div>
    </Tippy>
  );
}
